/** @format */

import {Typography} from '@mui/material';

import {StatStateDisplay, StatusDataInterface} from '../types';

const getStatusData = (
  statusToken: StatStateDisplay,
  projectTitle: string,
): StatusDataInterface | null => {
  switch (statusToken) {
    case 'INVALID_TOKEN':
      return {
        title: 'Недействительный токен',
        variant: 'error',
        projectTitle,
        PopoverContent: (
          <>
            <Typography>Токен доступа к рекламной платформе недействителен или истек</Typography>
            <Typography>Переподключите рекламную систему в настройках проекта</Typography>
          </>
        ),
      };
    case 'NOT_READY':
      return {
        title: 'Обрабатывается',
        variant: 'default',
        projectTitle,
        PopoverContent: (
          <>
            <Typography>Данные обрабатываются</Typography>
            <Typography>Когда проект будет готов, мы пришлем уведомление</Typography>
          </>
        ),
      };
    case 'NO_ACTIVE_ACCOUNTS':
      return {
        title: 'Нет активных аккаунтов',
        variant: 'error',
        projectTitle,
        PopoverContent: (
          <>
            <Typography>В подключенном рекламном кабинете нет активных кампаний</Typography>
            <Typography>
              Без активных кампаний нам нечего отслеживать. Запустите хотя бы одну или подключите
              другой кабинет
            </Typography>
          </>
        ),
      };
    case 'NO_2FA':
      return {
        title: 'Нет двухфакторной аутентификации',
        variant: 'error',
        projectTitle,
        PopoverContent: (
          <>
            <Typography>Не включена двухэтапная аутентификация</Typography>
            <Typography>
              Чтобы получить данные из Google Ads, нужно включить двухэтапную аутентификацию.
              Настройте ее в Гугл-кабинете
            </Typography>
          </>
        ),
      };
    case 'NO_TOKEN':
      return {
        title: 'Нет токена',
        variant: 'error',
        projectTitle,
        PopoverContent: (
          <>
            <Typography>Отсутствует токен доступа</Typography>
            <Typography>Подключите рекламную систему в настройках проекта</Typography>
          </>
        ),
      };
    case 'READY':
      return {
        title: 'Готово',
        variant: 'default',
        projectTitle,
        PopoverContent: <Typography>Все данные доступны и отображаются корректно</Typography>,
      };
    case 'NEW':
      return {
        title: 'Не настроен',
        variant: 'warning',
        projectTitle,
        PopoverContent: (
          <>
            <Typography>Проект не настроен</Typography>
            <Typography>Завершите настройку проекта</Typography>
          </>
        ),
      };
    default:
      return null;
  }
};

export {getStatusData};
